import * as React from "react";

import { cn } from "./Constants";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "mt-2 flex h-10 w-full rounded-md border border-custom-border-default bg-background px-3 py-2 ring-primary_1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary_1 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 text-primary_1 placeholder:text-primary_1/50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
